import { Remove, Straight } from '@mui/icons-material';
import { Box, IconButton, Stack, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';

interface Props {
  conditionType: string;
  conditionValue: React.ReactNode;
  priority: number;
  totalPrioritySuggestions?: number;
  removeCondition: () => void;
  handleReprioritizedPriceSuggestions?: (priceTypeIndex: number, prioritize: 'UP' | 'DOWN') => void;
}

export function PrioritizedSalesPriceCondition({
  conditionType,
  conditionValue,
  priority,
  totalPrioritySuggestions,
  removeCondition,
  handleReprioritizedPriceSuggestions,
}: Props) {
  return (
    <Stack
      direction="row"
      alignItems="center"
      gap={2}
      sx={{
        px: 1.5,
        py: 1,
        borderRadius: 1.5,
        border: '1px solid',
        borderColor: 'divider',
      }}
    >
      <Box
        sx={(theme) => ({
          width: 24,
          height: 24,
          flexShrink: 0,
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          bgcolor: theme.vars
            ? `rgba(${theme.vars.palette.success.mainChannel} / 0.15)`
            : alpha(theme.palette.success.main, 0.15),
          color: 'success.main',
          fontWeight: 'bold',
          fontSize: 13,
        })}
      >
        {priority}
      </Box>
      <Stack
        flexDirection="row"
        flexWrap="wrap"
        columnGap={2}
        alignItems="center"
        flexGrow={1}
        minWidth={0}
        sx={{ overflowWrap: 'anywhere' }}
      >
        <Typography minWidth={90} variant="body1">
          {conditionType}
        </Typography>
        {conditionValue}
      </Stack>
      <Stack flexDirection="row" flexShrink={0} justifyContent="flex-end">
        {handleReprioritizedPriceSuggestions && (
          <>
            <IconButton
              disabled={priority === 1}
              sx={{ p: 0 }}
              onClick={() => handleReprioritizedPriceSuggestions(priority - 1, 'UP')}
            >
              <Straight fontSize="small" />
            </IconButton>

            <IconButton
              disabled={priority === totalPrioritySuggestions}
              sx={{ p: 0 }}
              onClick={() => handleReprioritizedPriceSuggestions(priority - 1, 'DOWN')}
            >
              <Straight sx={{ rotate: '180deg' }} fontSize="small" />
            </IconButton>
          </>
        )}

        <IconButton sx={{ p: 0 }} onClick={removeCondition}>
          <Remove fontSize="small" />
        </IconButton>
      </Stack>
    </Stack>
  );
}
